import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateCouponPost = {
    path: "/affiliate/coupon",
    method: ERouteHttpVerb.POST
};
export { routeLocationAffiliateCouponPost };
